export default __webpack_public_path__ + "static/gs-4-copysnidbit-03da9c499d18ce6c29d31b29430bda2d.jpg";